module.exports = __webpack_public_path__ + "static/media/logo_small.f0d645d1.png";